export default __webpack_public_path__ + "static/media/myAccount.f4ee9342.svg";